import React from 'react';
import { TableHeaders } from '../app.constant';
import LABELS from '../ui-constants/en.json';

interface CopyContentProps {
  replyData: any;
  sourceSelected?: string;
  setShowCopyText: (show: boolean) => void;
  isCombined?:boolean;
}

const handleCopy = (
  replyData: any,
  setShowCopyText: (show: boolean) => void,
  someResposeId: string,
  sourceSelected: keyof typeof TableHeaders,
  isCombined = false
) => {
  const textContainer = document.querySelector(`${isCombined ? ".resCopyEmb" : ".resCopy"}${someResposeId}`) as HTMLElement | null;
  const allTableData = replyData?.relevantFiles || [];
   if (!textContainer) {
    console.error('Content not found!');
    return;
  }
  const tempDiv = document.createElement('div');
  tempDiv.style.position = 'absolute';
  tempDiv.style.left = '-9999px';

  // Add the summary text
  const summaryClone = textContainer.cloneNode(true) as HTMLElement;
  tempDiv.appendChild(summaryClone);

  // Create a table manually to include hidden content
  if (allTableData.length > 0) {
  const blankLineDiv = document.createElement('div');
  blankLineDiv.innerHTML = '&nbsp;';
  tempDiv.appendChild(blankLineDiv);

  const tempTable = document.createElement('table');
  tempTable.style.border = '1px solid black';
  tempTable.style.borderCollapse = 'collapse';
  tempTable.style.background = '#fff';

  // Create table header
  const headerRow = document.createElement('tr');
  if (TableHeaders[sourceSelected]) {
    TableHeaders?.[sourceSelected].forEach((header) => {
      const th = document.createElement('th');
      th.textContent = header;
      th.style.border = '1px solid black';
      th.style.padding = '5px';
      th.style.background = '#fff';
      th.style.color = '#000';
      headerRow.appendChild(th);
    });
  }

  tempTable.appendChild(headerRow);

  if (
    sourceSelected === 'Discover: Sector Insights' ||
    sourceSelected === 'EY-P Strategy projects'
  ) {
    allTableData.forEach((row: any) => {
      const tr = document.createElement('tr');
      [row.file_name, row.authors].forEach((cellData, index) => {
        const td = document.createElement('td');
        td.innerHTML =
          index === 0
          ? `${cellData}<br>(Slides ${row.page_number.map((it: any) => it).join(', ')})`
          : row.authors.map((it: any) => it.author_name);
        td.style.border = '1px solid black';
        td.style.padding = '5px';
        td.style.background = '#fff';
        td.style.color = '#000';
        tr.appendChild(td);
      });

      tempTable.appendChild(tr);
    });
  } else if (sourceSelected === 'Market reports') {
    allTableData.forEach((row: any) => {
      const tr = document.createElement('tr');
      [row.file_name, row.page_number, row.source].forEach((cellData) => {
        const td = document.createElement('td');
        td.textContent = cellData || '';
        td.style.border = '1px solid black';
        td.style.padding = '5px';
        td.style.background = '#fff';
        td.style.color = '#000';
        tr.appendChild(td);
      });
      tempTable.appendChild(tr);
    });
  } else if (sourceSelected === 'Experts') {
    const aboveTableDiv = document.createElement('div');
    aboveTableDiv.textContent = LABELS.EY_EXPERT_DISCLAIMER;
    aboveTableDiv.style.marginBottom = '10px';
    tempDiv.appendChild(aboveTableDiv);
    allTableData.forEach((row: any) => {
      const tr = document.createElement('tr');
      const authorsName = row.Authors.map((author: any) => author.author_name).join(', ');
      const authorsRole = row.Authors.map((author: any) => author.role).join(',');
      const geographies = row.Geography.map((geo: any) => geo).join(', ');

      [authorsName, authorsRole, row.Project_type, row.Project_End_Date, geographies].forEach(
        (cellData, index) => {
          const td = document.createElement('td');
          td.textContent = index === 3 ? new Date(cellData)
          .toLocaleString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
          })
          .split(' ')
          .join(' ')
          :cellData || '';
          td.style.border = '1px solid black';
          td.style.padding = '5px';
          td.style.background = '#fff';
          td.style.color = '#000';
          tr.appendChild(td);
        }
      );
      tempTable.appendChild(tr);
    });
  }
  // Append full table to tempDiv
  tempDiv.appendChild(tempTable);
  }
  document.body.appendChild(tempDiv); // Attach to DOM

  // Select and copy content
  const range = document.createRange();
  range.selectNodeContents(tempDiv);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);
  document.execCommand('copy');

  // Cleanup
  selection?.removeAllRanges();
  document.body.removeChild(tempDiv);

  setShowCopyText(true);
  setTimeout(() => {
    setShowCopyText(false);
  }, 1000);
};

const CopyContent: React.FC<CopyContentProps> = ({ replyData, setShowCopyText }) => {
  return null;
};

export { handleCopy, CopyContent };
export type { CopyContentProps };
export default CopyContent;
